// Path: src\Components\Popup\WinningPopup.jsx
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Popup from "./BasePopup";
import Diamond from "../../images/Diamond.png"
import { base_apis, url } from "../../config/url";
import { getPrizePool } from "../../api/contest.api";
import { tournamentPricePointPool } from "../../api/tournament.api";
import { useEffect } from "react";
import ListLoader from "../Common/ListLoader";

const WinningBreakup = ({ isOpen, title, onClose, prizePool, tournament, contestId, contestData, popupType }) => {
  const [activeTab, setActiveTab] = useState(0);
  const [loading, setLoading] = useState(false);

  const [prizePoolInfo, setPrizePoolInfo] = useState([]);
  const [pointPoolInfo, setPointPoolInfo] = useState([]);
  const [prizePoolAmount, setPrizePoolAmount] = useState('');
  const [contestInfo, setContestInfo] = useState(null);
  const [tournamentInfo, setTournamentInfo] = useState(null);
  const { t } = useTranslation();
  const getCurrencyImg = (data, currencyType) => {

    let result;
    if (currencyType === "outCurrency") {
      result = data.find(item => item?.[currencyType]?.img?.default);
      return result ? `${base_apis?.imageUrl}${result.outCurrency.img.default}` : Diamond;
    } else if (currencyType === "inCurrency") {
      result = data.find(item => item?.[currencyType]?.img?.default);
      return result ? `${base_apis?.imageUrl}${result.inCurrency.img.default}` : Diamond;
    }


  };

  useEffect(() => {
    if (popupType === "contest") {
      fetchwinningbreakup(contestId)
      setContestInfo(contestData)

    } else if (popupType === "tournament") {
      fetchTournamentwinningbreakup(contestId)
      setTournamentInfo(contestData)
      setPrizePoolAmount(contestData?.prizePool)
    }
  }, [])

  const fetchwinningbreakup = async (data) => {
    try {
      setLoading(true)
      const res = await getPrizePool(data);
      if (res?.success && res?.data) {
        setPrizePoolInfo(res?.data?.prizePoolInfo)
        setPrizePoolAmount(res?.data?.prizePool)
      }
      else {
        prizePoolInfo([])
        prizePoolAmount(0)
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  };

  const fetchTournamentwinningbreakup = async (data) => {
    try {
      setLoading(true)
      const res = await tournamentPricePointPool(data);
      if (res?.success && res?.data) {
        setPrizePoolInfo(res?.data?.prizePooInfo)
        setPointPoolInfo(res?.data?.pointpool)
      }
      else {
        prizePoolInfo([])
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  };

  return (
    <Popup isOpen={isOpen} title={title} onClose={onClose}>
      {loading && <div className='w-100 d-flex justify-content-center no-record-found-center' style={{height:"15rem"}}> <ListLoader /></div>}
      {(!loading && popupType == 'contest') && (
        <div className="popup-container p-0">
          {/* Conditional Content */}
          {prizePoolInfo && prizePoolAmount && prizePoolInfo.length > 0 && (
            <div className="content-container">
              <div>
                <div className="prize-pool-title mb-2">{t('tournament_list.prize_pool')}</div>
                <div className="prize-amount mb-5">
                  {prizePoolAmount > 0 ? prizePoolAmount : ''}
                  {
                    contestData?.winningModel === 'perRank' &&
                    <span className="icon me-2">
                      
                      <img
                      style={{marginLeft:"0.313rem",marginBottom:"3px"}}
                        className="winning-currency-icon winning-currency-icon-fixs winning-detailcurrency-icon-fix"
                        src={`${getCurrencyImg(contestData?.currency, 'outCurrency')}`}
                        alt=""
                      />
                    </span>
                  }
                </div>

                <div className={`rank-details ${prizePoolInfo.length > 5 ? 'scrollable' : ''}`}>
                  {prizePoolInfo?.length > 0 ? (
                    prizePoolInfo?.map((detail, index) => (
                      <p className="ranksdet" key={index}>
                        {t('tournament_list.rank')}: {detail.rankFrom}{detail.rankTo !== '0' && detail.rankFrom !== detail.rankTo ? "-" : ""}{detail.rankTo !== '0' && detail.rankFrom !== detail.rankTo ? detail.rankTo : ""}
                        <span>
                          <span>{detail?.amount || 0}</span>
                          {
                            contestData?.winningModel === 'perRank' &&
                            <span className="icon me-2">
                              <img
                                className="winning-detailcurrency-icon winning-detailcurrency-icon-fix"
                                src={`${getCurrencyImg(contestData?.currency, 'outCurrency')}`}
                                alt="currency"
                              />
                            </span>
                          }
                        </span>
                      </p>
                    ))
                  ) : (
                    <p>{contestData?.prizePoolInfo}</p>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      )}

      {(!loading && popupType == 'tournament') && (
        <div className="popup-container p-0">
          {/* Tabs */}
          {pointPoolInfo?.length > 0 && (
            <div className="tab-container">
              <div
                className={activeTab === 0 ? "tabspop active-tabspop" : "tabspop"}
                onClick={() => setActiveTab(0)}
              >
                {t('tournament_list.prize_pool')}
              </div>

              <div
                className={activeTab === 1 ? "tabspop active-tabspop" : "tabspop"}
                onClick={() => setActiveTab(1)}
              >
                {t('tournament_list.point_pool')}
              </div>
            </div>
          )}

          {/* Conditional Content */}
          <div className="content-container">
            {activeTab === 0 ? (
              <div>
                <div className="prize-pool-title mb-2">{t('tournament_list.prize_pool')}</div>
                <div className="prize-amount mb-5">
                  {tournamentInfo?.prizePoolType === 'amount' ? tournamentInfo?.prizePool : tournamentInfo?.rewardDisplayText}
                  {
                    tournamentInfo?.prizePoolType === 'amount' &&
                    <span className="icon me-2">
                      <img
                        className="winning-currency-icon winning-detailcurrency-icon-fix"
                        src={`${getCurrencyImg(tournamentInfo?.currency, 'outCurrency')}`}
                        alt=""
                      />
                    </span>
                  }
                </div>
                <div className={`rank-details ${prizePool?.prizePooInfo?.length > 5 ? 'scrollable' : ''}`}>
                  {prizePoolInfo?.length > 0 ? (
                    prizePoolInfo?.map((detail, index) => (
                      <p className="ranksdet" key={index}>
                        {t('tournament_list.rank')}: {detail.rankFrom}{detail.rankTo !== '0' && detail.rankFrom !== detail.rankTo ? "-" : ""}{detail.rankTo !== '0' && detail.rankFrom !== detail.rankTo ? detail.rankTo : ""}
                        <span>
                          <span>{detail?.amount || detail?.prize || 0}</span>
                          {
                            tournamentInfo?.prizePoolType === 'amount' &&
                            <span className="icon me-2">
                              <img
                                className="winning-detailcurrency-icon winning-detailcurrency-icon-fix"
                                src={`${getCurrencyImg(tournamentInfo?.currency, 'outCurrency')}`}
                                alt="currency"
                              />
                            </span>
                          }
                        </span>
                      </p>
                    ))
                  ) : (
                    <p>{tournamentInfo?.prizePoolInfo}</p>
                  )}
                </div>
              </div>
            ) : (
              <div>
                <div className={`rank-details ${pointPoolInfo?.length > 5 ? 'scrollable' : ''}`}>
                  {pointPoolInfo?.map((detail, index) => (
                    <p className="ranksdet" key={index}>
                      {t('tournament_list.rank')}: {detail.rankFrom}{detail.rankTo !== '0' && detail.rankFrom !== detail.rankTo ? "-" : ""}{detail.rankTo !== '0' && detail.rankFrom !== detail.rankTo ? detail.rankTo : ""} <span>{detail.point}</span>
                    </p>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      )}

    </Popup>
  );
};

export default WinningBreakup;
